import { Link } from "react-router-dom";

import { MDBMask, MDBView, MDBBtn, MDBIcon } from "mdbreact";

import heroImage from "Styles/img/home/heroFullScreen.jpg";
import locale from "locale";

import ROUTES from "Constants/routes.constants";
import EXTERNAL_LINK from "Constants/external-links.constants";

export default function HomeHero() {
  return (
    <MDBView src={heroImage} fixed>
      <MDBMask className="moz-p-home-hero">
        <h1 className="heading-primary moz-p-home-hero__heading">
          {locale.COMMON.TOURISTIC_AGENCY}
          <br />
          {locale.COMMON.MOZAIK}
          <span className="moz-p-home-hero__heading--emphazed">
            {locale.COMMON.NUM_021}
          </span>
        </h1>
        <hr className="thick-hr" />
        <p className="lead mx-3 mx-md-auto moz-p-home-hero__lead">
          {locale.HOME.SLOGAN}
        </p>
        <br />
        <div className="moz-p-home__button-wraper">
          <Link to={ROUTES.COMMON.TRAVELS}>
            <MDBBtn color="primary" className="moz-p-home-hero__button">
              {locale.TRAVELS.TRAVELS}
            </MDBBtn>
          </Link>
          <a href="tel://021424735">
            <MDBBtn
              outline
              color="white"
              className="d-block d-md-none moz-p-home-hero__button"
            >
              {locale.COMMON.CALL} {locale.COMMON.MAIN_PHONE_NUMBER}
            </MDBBtn>
          </a>
        </div>
        <div className="d-none d-md-block moz-p-home-hero__action-box moz-p-home-hero__action-box--phone">
          <p className="moz-p-home-hero__action-box-item">
            <a href="tel://021424735">
              <MDBIcon icon="phone" />
              <span className="moz-p-home-hero__action-box-item--phone">
                {locale.COMMON.MAIN_PHONE_NUMBER}
              </span>
            </a>
          </p>
          <p className="moz-p-home-hero__action-box-item">
            <a href="tel://021455500">
              <MDBIcon icon="phone" />
              <span className="moz-p-home-hero__action-box-item--phone">
                {locale.COMMON.SECOND_PHONE_NUMBER}
              </span>
            </a>
          </p>
        </div>
        <div className="moz-p-home-hero__action-box moz-p-home-hero__action-box--social">
          <div className="moz-p-home-hero__action-box-item">
            <a
              href={EXTERNAL_LINK.SOCIAL_MEDIA.FACEBOOK}
              target="blank"
              className="moz-p-home-hero__action-box-item--social"
            >
              <MDBIcon fab icon="facebook-f" className="social" size="2x" />
            </a>
          </div>
          <div className="moz-p-home-hero__action-box-item">
            <a
              href={EXTERNAL_LINK.SOCIAL_MEDIA.INSTAGRAM}
              target="blank"
              className="moz-p-home-hero__action-box-item--social"
            >
              <MDBIcon fab icon="instagram" className="social" size="2x" />
            </a>
          </div>
        </div>
      </MDBMask>
    </MDBView>
  );
}
